import React, { useState } from "react";
import NoFooterModal from "../NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import OTPbox from "sushiweb/InputTypes/OTPbox";
import variables from "../../../constants/assets/variables";
import styled from "styled-components";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button/Button";

const OTPModalWithPhoneNumber = ({
  phone,
  heading = "Verify OTP",
  handleClose,
  getOTP,
  handleOTPVerify,
}) => {
  const [otp, setOtp] = useState("");
  const [otpLen, setOtpLen] = useState(0);

  const handleChange = (e) => {
    setOtpLen(e.target.value);
  };

  //otp handling
  const handleAccept = (otp) => {
    setOtp(otp);
  };

  const handleVerification = (e) => {
    e.preventDefault();
    handleOTPVerify(otp);
  };

  return (
    <OTPModalContainer className="otp-modal-with-phone">
      <NoFooterModal
        header
        heading={heading}
        id="verifyOTPModal"
        handleClose={handleClose}
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="OTPModalSubmit"
              disabled={!otp}
              onClick={handleVerification}
              className="sushi-btn"
            >
              Continue & verify
            </Button>
          </BottomSectionModal>
        }
      >
        <Input
          id="sushi-input"
          data-testid="phoneNumberOTP"
          fullWidth={true}
          label="Phone number"
          disabled={true}
          value={phone}
        />
        <p className="mt-30 mb-10 medium" style={{ color: variables.grey700 }}>
          Enter OTP
        </p>
        <OTPbox
          id="otpModalInput"
          onChange={handleChange}
          length={6}
          fnInputFill={handleAccept}
          inputType="number"
        />
        <h3 onClick={() => getOTP()} className="mt-20 medium">
          Resend OTP
        </h3>
      </NoFooterModal>
    </OTPModalContainer>
  );
};

const OTPModalContainer = styled.div`
  #otpModalInput {
    border: unset;
    height: unset;
    border-bottom: 2px solid ${variables.red500};
    border-radius: unset;
    margin: 0 10px;
    max-width: 4rem;
  }
  h3 {
    text-align: right;
    color: ${variables.red500};
    font-size: 0.875rem;
    cursor: pointer;
  }
  button {
    max-width: 100% !important;
    width: 100%;
  }
`;

export default OTPModalWithPhoneNumber;
